export let trackingItemsMixinBlock = {
	initTrackingItems: (self, $items) => {
		self.$element = self.$element || $(self.element);

		let trackingId = self.$element.data('trackingId');
		if(!_.isNil(trackingId) && trackingId !== '') {
			let $tracker = $('[data-pg][data-tracker="true"]');

			if(!($tracker && $tracker.length > 0)) {
				console.error('TrackingItemsMixinBlock::Error', 'Please ensure that the [data-pg][data-tracker="true"] element exists');
				return;
			}

			if(!($items && $items.length > 0)) {
				console.error('TrackingItemsMixinBlock::Error', 'Please supply jQuery object for the list of clickable items');
				return;
			}

			$items.each((index, element) => {
				let $element = $(element);
				$element.attr('data-tracking-item-id', index);
				$element.attr('data-tracking-item-complete', false);
			});

			let activeItems = [];

			$items.on('click', (event) => {
				let $element = $(event.currentTarget);
				let trackingItemId = $element.data('trackingItemId'); // TrackingItem of the item inside the block

				// If the item is active
				let isFound = _.find(activeItems, (item) => {
					return item === trackingItemId;
				});
				if(!isFound) {
					activeItems.push(trackingItemId);
					$element.attr('data-tracking-item-complete', true); // Mark item as complete

					if($items.length === activeItems.length) {
						$tracker.trigger('tracking.complete', {
							$element: self.$element,
							trackingId: trackingId
						});
						self.$element.data('trackingComplete', true);
					}
				}
			});
		}
	}
};
